import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import NoDataToDisplay from "highcharts/modules/no-data-to-display";
import { React, useEffect, useState } from "react";
NoDataToDisplay(Highcharts);

/**
 * @description 설비진단 > 예지정비 차트(Co,O2)
 * @author SONJIEUN
 * @date 01/08/2025
 * @param {*}
 * @return  설비진단 > 예지정비 차트(Co,O2)
 */
const UI_3_5_ChartScatter = (props) => {
    const targetO2 = props.data.targetO2;
    const targetCo = props.data.targetCo;
    const xy = props.data.xy;
    const limit = props.data.limit;
    const data = props.data.length !== 0? props.data.data : [];
    const name = props.data.name;

    const options_Scatter = {
        chart: {

            zooming: {
                type: 'xy'
            },
            backgroundColor: "transparent",
            showNoData: 'true',

        },
        title: { text: null },

        subtitle: {
            text: name
        },

        xAxis: {
            title: {
                text: 'O2 농도(%)'
            },
            labels: {
                format: '{value}'
            },
            lineColor: '#555',
            gridLineColor: '#555',
            gridLineWidth: 1,
            min: 0,
            max: 10,
            plotLines: [{
                color: 'red',
                dashStyle: 'dot',
                width: 2,
                value: limit,
                label: {
                    rotation: 0,
                    y: 15,
                    style: {
                        fontStyle: 'italic',
                        color: 'white'
                    },
                    text: '관리목표 O2 ' + targetO2 + '%, CO ' + targetCo + 'ppm',

                },
            }],

        },
        yAxis: {
            title: {
                text: 'CO농도(PPM)'
            },
            labels: {
                format: '{value}'
            },
            lineColor: '#555',
            gridLineColor: '#555',
            min: 0,
            max: 120,
        },
        legend: {
            enabled: false
        },

        plotOptions: {
            scatter: {
                marker: {
                    radius: 2.5,
                    symbol: 'circle',
                    states: {
                        hover: {
                            enabled: true,
                            lineColor: 'rgb(100,100,100)'
                        }
                    }
                },

            }
        },
        tooltip: {
            pointFormat: 'O2: {point.x}% <br/> CO: {point.y}PPM'
        },
        series: [{
            type: 'line',
            name: '농도',
            color: "green",
            marker: {
                fillColor: "green",
                lineWidth: 0,
                lineColor: "white",
                radius: 3,
            },
            data: data

        }, {
            type: 'scatter',
            name: '현 위치점',
            data: [
                xy,
            ],
            marker: {
                fillColor: "white",
                lineWidth: 0,
                lineColor: "white",
                radius: 8,
            },
        }],
    }

    return (
        <>
            <figure className="highcharts-figure">
                <HighchartsReact
                    highcharts={Highcharts}
                    options={options_Scatter} //options_Scatter , options_Line
                />
            </figure>

        </>
    );
};

export default UI_3_5_ChartScatter;
